/**
 * 客户端容器类型
 */
export var CLIENT_TYPE;
(function (CLIENT_TYPE) {
    CLIENT_TYPE["meituan"] = "meituan";
    CLIENT_TYPE["mmp"] = "mmp";
    CLIENT_TYPE["dianping"] = "dianping";
    CLIENT_TYPE["waimai"] = "waimai";
    CLIENT_TYPE["lvxing"] = "lvxing";
    CLIENT_TYPE["maicai"] = "maicai";
    CLIENT_TYPE["xiaoxiang"] = "xiaoxiang";
    CLIENT_TYPE["zhenguo"] = "zhenguo";
    CLIENT_TYPE["maoyan"] = "maoyan";
    CLIENT_TYPE["mobai"] = "mobai";
    CLIENT_TYPE["daxiang"] = "daxiang";
    CLIENT_TYPE["conch"] = "conch";
    CLIENT_TYPE["weixin"] = "weixin";
    CLIENT_TYPE["weixinapp"] = "weixinapp";
    CLIENT_TYPE["alipay"] = "alipay";
    CLIENT_TYPE["other"] = "other";
    CLIENT_TYPE["mhotel"] = "mhotel";
    CLIENT_TYPE["mwaimai"] = "mwaimai";
    CLIENT_TYPE["xuexiqg"] = "xuexiqg";
    CLIENT_TYPE["ecomapp"] = "ecomapp";
    CLIENT_TYPE["dpmerchant"] = "dpmerchant";
    CLIENT_TYPE["crowdsource"] = "crowdsource";
    CLIENT_TYPE["ioscrowdsource"] = "ioscrowdsource";
    CLIENT_TYPE["delivery"] = "delivery";
    CLIENT_TYPE["iosdelivery"] = "iosdelivery";
    CLIENT_TYPE["newsarticle"] = "newsarticle";
    CLIENT_TYPE["douyin"] = "douying";
    CLIENT_TYPE["tripbiz"] = "tripbiz";
    CLIENT_TYPE["unknown"] = "unknown";
    /**
     * 美团优选App
     */
    CLIENT_TYPE["mtyxapp"] = "mtyxapp";
    /**
     * 美团管家智能版
     */
    CLIENT_TYPE["erpbosspro"] = "erpbosspro";
    /**
     * 美团百川App
     */
    CLIENT_TYPE["baichuan"] = "baichuan";
    /**
     * 美团直播助手 App
     */
    CLIENT_TYPE["mtliveanchor"] = "mtliveanchor";
    /**
     * 美团团购快应用，包括：华为、vivo、oppo、小米
     */
    CLIENT_TYPE["mtquickapp"] = "mtquickapp";
})(CLIENT_TYPE || (CLIENT_TYPE = {}));
